<div class="testimonial-section">
  <div class="container">
    <div class="section-header text-center mb-5">
      <h2 class="section-title">Testimonials</h2>
      <div class="title-underline"></div>
      <p class="section-description">See What Our Clients Have To Say</p>
    </div>

    <div class="testimonial-wrapper">
      <div class="testimonial-container" #testimonialContainer>
        <div class="testimonial-card" *ngFor="let testimonial of testimonialData">
          <h3 class="testimonial-content" [innerHTML]="testimonial.content"></h3>
          <h5 class="testimonial-author">- {{ testimonial.title }}</h5>
          <h6 class="testimonial-subtitle">{{ testimonial.subtitle }}</h6>
        </div>
      </div>

      <!-- Navigation Arrows -->
      <button class="nav-arrow prev" (click)="scrollLeft()" aria-label="Previous">
        <mat-icon>chevron_left</mat-icon>
      </button>
      <button class="nav-arrow next" (click)="scrollRight()" aria-label="Next">
        <mat-icon>chevron_right</mat-icon>
      </button>
    </div>
  </div>
</div>